import React from 'react';
import { Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import maybeFormatDate from './maybeFormatDate';

const baseColumns = [
    {
        field: 'name',
        headerName: 'Text',
        flex: 1
    },
    {
        field: 'value',
        headerName: 'Count',
        align: 'right',
        headerAlign: 'right'
    }
];

const row = {
    field: 'row',
    headerName: 'Row',
    flex: 0.3
};

const column = {
    field: 'column',
    headerName: 'Column',
    flex: 0.3
};

const SimpleTable = ({ data, columns = false, rows = false, chartHeight = 300, inputType = null, textColumnName = null }) => {
    const height = Boolean(chartHeight >= 300) ? chartHeight : 300;

    let tableColumns = rows
        ? [row, column, ...baseColumns]
        : columns
            ? [column, ...baseColumns]
            : baseColumns;

    if (textColumnName) {
        tableColumns = tableColumns.map(e => {
            if (e.field === 'name') {
                return {
                    ...e,
                    headerName: textColumnName
                };
            }

            return e;
        });
    }

    const tableData = data.map(e => {
        const { str } = maybeFormatDate(e.name, inputType);

        return {
            ...e,
            name: str
        };
    });

    return (
        <Box sx={{ height, width: '100%' }}>
            <DataGrid
                rows={tableData}
                columns={tableColumns}
                initialState={{
                    pagination: {
                        paginationModel: {
                            pageSize: 10
                        }
                    }
                }}
                pageSizeOptions={[10, 20, 50]}
                disableRowSelectionOnClick
                getRowId={row => rows
                    ? `${row.row}${row.column}${row.name}`
                    : columns
                        ? `${row.column}${row.name}`
                        : row.name}
            />
        </Box>
    );
};

export default SimpleTable;
